import React, { createContext, useContext, useReducer } from 'react';
import { TrackingResponse } from '../Interfaces/Tracking.interface';

type FormAction = {
  type: string;
  payload: any;
};

const trackingInitialState: TrackingResponse = {
  loading: true,
  documents: [],
};

const TrackingReducer = (state: TrackingResponse, action: FormAction): TrackingResponse => {
  switch (action.type) {
    case 'LOADING_START':
      return {
        ...state,
        loading: true,
      };

    case 'LOADING_END':
      return {
        ...state,
        loading: false,
      };

    case 'UPDATE_DOCUMENTS':
      return {
        ...state,
        documents: action.payload,
      };

    case 'CLEAN_DOCUMENTS':
      return {
        ...state,
        loading: false,
        documents: [],
      };
    default:
      return state;
  }
};

const TrackingContext = createContext<{
  state: TrackingResponse;
  dispatch: React.Dispatch<FormAction>;
}>({
  state: trackingInitialState,
  dispatch: () => null,
});

const TrackingProvider = ({ children }: any) => {
  const [state, dispatch] = useReducer(TrackingReducer, trackingInitialState);
  return <TrackingContext.Provider value={{ state, dispatch }}>{children}</TrackingContext.Provider>;
};

const useTrackingContext = () => useContext(TrackingContext);

export { TrackingProvider, useTrackingContext };
